import { Box, Grid, LinearProgress, Paper, IconButton, Tooltip } from '@mui/material';
import {
  DataGridProProps,
  GridColumnOrderChangeParams,
  GridColumnVisibilityModel,
  GridRowClassNameParams,
  GridSortModel,
  MuiEvent,
  useGridApiRef,
  GridPagination,
} from '@mui/x-data-grid-pro';
import { DataGridPro } from '@mui/x-data-grid-pro/DataGridPro/DataGridPro';
import React, { useCallback, useState } from 'react';
import { useSelector } from 'store/hooks';
import { useAppState } from 'store/Provider';
// import { clearSelectedFilterAction, selectFilterAction } from 'store/actions/filterActions';

import { changePageSizeAction, changePageAction, sortKpimetricGridAction } from 'store/actions/dashboardActions';
import { kpiMetricColumnsFields, useColumns } from './KpiMetricsService';
import { useTranslation } from 'react-i18next';

import { DownloadIcon } from 'components/CustomIcons';

type KpiMetricsProps = {
  FilterKpiMetric: any;
  dashboardKpiGridData: any[];
  FilterNeeded: boolean;
  isLoading?: boolean;
  notaskImg?: string;
  onDownloadXlsx?: () => void;
  showDownload?: boolean;
};

const KpiMetricsTable = (props: KpiMetricsProps) => {
  const { FilterKpiMetric, dashboardKpiGridData, isLoading: loadingProp, onDownloadXlsx, showDownload } = props;
  const { dashboard } = useSelector((state) => state);
  const { loadings } = useSelector((state) => state);

  const kpimetric_type = FilterKpiMetric?.page_title ?? 'Workunit';
  const columns = useColumns(kpiMetricColumnsFields, kpimetric_type);
  // Specify which column fields should be sortable. Update this list as needed.
  const sortableFields: string[] = [
    'id',
    'Name_spec',
    'Ref_spec',
    'client',
    'scope',
    'price',
    'workload',
    'delivery_date',
    'Status',
    'pendingat',
    'bm',
    'delivery_manager',
    'Order_number',
    'affair_otp',
    'consultant_fullname',
    'Affair_name',
    'customer',
    'bu',
    'rating',
    'workunit_name',
    'workunit_reference',
  ];
  console.log(kpimetric_type, FilterKpiMetric);
  const metricTooltip = FilterKpiMetric?.page_title ? `Download ${FilterKpiMetric.page_title} Excel` : 'Download Excel';
  // Build columns for the DataGrid and set `sortable` only for allowed fields
  const dataGridColumns = (columns[FilterKpiMetric?.page_title] ?? []).map((col) => ({
    ...col,
    sortable: sortableFields.includes(String(col.field)),
  }));

  const { currentPage, pageSize } = dashboard;

  const { totalItems } = dashboard?.pageHandler;
  const { dispatch } = useAppState();
  const [t] = useTranslation();
  //  const order = useSelector((state) => state?.deliverable?.order);
  const apiRef = useGridApiRef();

  const [currentPageVal, setCurrentPageVal] = useState(currentPage);

  // useEffect(() => {}, [FilterKpiMetric]);

  // useLayoutEffect(() => {
  //   dispatch(clearSelectedFilterAction());
  //   return () => {
  //     dispatch(clearSelectedFilterAction());
  //   };
  // }, []);

  const onPageSizeChange = (pageSize: number) => {
    dispatch(changePageSizeAction(pageSize));
    // dispatch(filterTotalFlagAction(true));
  };

  const onPageChange = (page: number) => {
    setCurrentPageVal(page);
    dispatch(changePageAction(Number(page)));
    // setTimeout(() => {
    //   dispatch(filterTotalFlagAction(true));
    // }, 500);
  };

  // useEffect(() => {
  //   // const handler = setTimeout(() => {
  //   dispatch(changePageAction(Number(currentPageVal)));
  //   dispatch(filterTotalFlagAction(true));
  //   // }, 500);

  //   // return () => {
  //   //   clearTimeout(handler);
  //   // };
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [currentPageVal]);

  const onSortModelChange = React.useCallback((sortModel: GridSortModel) => {
    if (currentPage !== 0) {
      setCurrentPageVal(0);
      dispatch(changePageAction(0));
      dispatch(sortKpimetricGridAction(sortModel));
    } else {
      dispatch(sortKpimetricGridAction(sortModel));
    }

    // dispatch(filterTotalFlagAction(true));
  }, []);

  const getRowClassName = useCallback((params: GridRowClassNameParams) => {
    if (params.row.label && params.row.label.includes('cancelled')) return 'Mui-disabled';
    return params.indexRelativeToCurrentPage % 2 === 0 ? 'Mui-even' : 'Mui-odd';
  }, []);

  const [filterButtonEl, setFilterButtonEl] = React.useState<HTMLButtonElement | null>(null);

  const dataTableProps: Omit<DataGridProProps, 'columns'> = {
    rows: dashboardKpiGridData?.orders?.datas ?? [],
    // onSortModelChange,
    onPageChange,
  };

  const CustomPagination = ({ showDownload, onDownloadXlsx, ...paginationProps }: any) => (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      {showDownload && onDownloadXlsx && (
        <Tooltip title={metricTooltip}>
          <IconButton
            onClick={onDownloadXlsx}
            sx={{
              mr: 1,
              color: '#1A73E8',
              '& svg': { color: '#1A73E8' },
            }}
          >
            <DownloadIcon />
          </IconButton>
        </Tooltip>
      )}

      <GridPagination {...paginationProps} />
    </Box>
  );

  return (
    <>
      <Box
        sx={{
          height: '70vh',
          overflow: 'auto',
          scrollbarWidth: 'none', // Firefox
          '&::-webkit-scrollbar': {
            display: 'none', // Chrome, Safari, Edge
          },
        }}
      >
        {FilterKpiMetric?.page_title && (
          <DataGridPro
            //   initialState={{
            //     pinnedColumns: { left: [GRID_CHECKBOX_SELECTION_COL_DEF.field, 'id', 'tags', 'workunit_name'] },
            //   }}
            columns={dataGridColumns}
            components={{
              // Toolbar: CustomToolbar,
              LoadingOverlay: LinearProgress,
              Pagination: (props) => (
                <CustomPagination {...props} showDownload={showDownload} onDownloadXlsx={onDownloadXlsx} />
              ),
            }}
            componentsProps={{
              loadingOverlay: { style: { zIndex: 9999 } },
              panel: {
                anchorEl: filterButtonEl,
                placement: 'bottom-end',
              },
              toolbar: {
                setFilterButtonEl,
              },
            }}
            loading={loadingProp}
            // className={selectedBLAllDeliverables ? 'test' : 'test'}
            {...dataTableProps}
            apiRef={apiRef}
            autoHeight={false}
            pagination
            disableColumnMenu
            headerHeight={100}
            rowHeight={80}
            onPageSizeChange={onPageSizeChange}
            pageSize={pageSize}
            rowsPerPageOptions={[10, 25, 50, 100, 200]}
            page={currentPageVal}
            paginationMode="server"
            sortingMode="server"
            keepNonExistentRowsSelected
            disableSelectionOnClick
            rowCount={totalItems}
            //   selectionModel={selectedBLDeliverablesModel}
            // onPageChange={onPageChange}
            onSortModelChange={onSortModelChange}
            //   onSelectionModelChange={onSelectionModelChange}
            getRowClassName={getRowClassName}
            // checkboxSelection: !state.selectedAllDeliverables, // KpiMetric ignore unselect or select after a select all
            //   checkboxSelection
            sx={{
              '& .Mui-disabled': {
                background: '#e1e5ef',
                opacity: '.9',
                pointerEvents: 'initial',
              },
              overflow: 'auto',
              mb: { xs: 30, md: 5 },

              '& .MuiDataGrid-columnHeaderTitleContainer .MuiDataGrid-sortIcon': {
                display: 'none !important',
              },
              '& .MuiDataGrid-columnHeader:focus': {
                outline: 'none', // Prevents focus outline on sortable headers
              },
              '& .MuiDataGrid-columnHeader:focus-within': {
                outline: 'none',
              },
              '& .MuiDataGrid-row': {
                border: '1px solid #e9e9e9',
              },
              '& .MuiDataGrid-columnHeader': {
                // borderTop: '1px solid #e9e9e9',
                borderBottom: '1px solid #e9e9e9',
              },
            }}
          />
        )}
      </Box>
    </>
  );
};

export default KpiMetricsTable;
